<template>
	<div>

		<section id="home" class="video-hero">
		<div class="overlay top-bk"></div>
			<!-- <a 
				ref="player"
				class="player" 
				data-property="{videoURL:'https://www.youtube.com/watch?v=vqqt5p0q-eU',containment:'#home', showControls:false, autoPlay:true, loop:true, mute:true, startAt:0, opacity:1, quality:'default'}"
			></a>  -->
		</section>

		<PlansBoxs/>

	</div>
</template>

<script>
import PlansBoxs from "./PlansBoxs";

export default {
	name: "AccountPlans",
	components: {
		PlansBoxs
	},
  mounted() {
    this.$helpers.ga.openPage({ page: 'plans', title: 'Plans' });
		this.$helpers.scrollTop(0);
  }
};
</script>